import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

/**
 * Live wall-clock showing current South African Standard Time (UTC+2).
 * Updates every second.
 */
export default function SastClock({ className = "" }) {
  const [time, setTime] = useState(() => formatNowSast());

  useEffect(() => {
    const id = setInterval(() => setTime(formatNowSast()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className={`flex items-center gap-1 text-xs font-mono text-gray-700 bg-gray-50 px-2 py-1 rounded ${className}`}
      title="System time (SAST)"
      data-testid="sast-clock"
    >
      <Clock className="h-3 w-3 text-blue-600" />
      <span>{time}</span>
    </div>
  );
}

function formatNowSast() {
  // Format current time in SAST regardless of the user's local timezone
  return new Date().toLocaleTimeString("en-ZA", {
    timeZone: "Africa/Johannesburg",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}
